import { defineComponent as p, ref as y, inject as v, computed as n, openBlock as i, createElementBlock as r, normalizeClass as d, unref as o, Fragment as z, renderSlot as m, createBlock as w, withCtx as L, createCommentVNode as B, createElementVNode as t } from "vue";
import "../button-group/index.js";
import { buttonProps as C, buttonEmits as _ } from "./button.js";
import { useNamespace as V } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import $ from "../Icon.vue.js";
/* empty css           */
import "./button.css";
import { buttonGroupContextKey as E } from "../button-group/button-group.js";
const M = ["aria-disabled", "disabled"], N = /* @__PURE__ */ t("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, [
  /* @__PURE__ */ t("path", {
    fill: "currentColor",
    d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
  })
], -1), H = p({
  name: "ApButton"
}), O = /* @__PURE__ */ p({
  ...H,
  props: C,
  emits: _,
  setup(c, { emit: f }) {
    const l = c, u = f, g = y(), a = V("button"), s = v(E, void 0), b = n(() => l.type || (s == null ? void 0 : s.type) || ""), k = n(() => l.size || (s == null ? void 0 : s.size)), h = (e) => {
      u("click", e);
    };
    return (e, j) => (i(), r("button", {
      ref_key: "_ref",
      ref: g,
      type: "button",
      class: d([
        o(a).b(),
        o(a).m(b.value),
        o(a).m(k.value),
        o(a).is("text", e.text),
        o(a).is("plain", e.plain),
        o(a).is("loading", e.loading),
        o(a).is("round", e.round),
        o(a).is("circle", e.circle),
        o(a).is("disabled", e.disabled)
      ]),
      "aria-disabled": e.disabled || e.loading,
      disabled: e.disabled || e.loading,
      onClick: h
    }, [
      e.loading ? (i(), r(z, { key: 0 }, [
        e.$slots.loading ? m(e.$slots, "loading", { key: 0 }) : (i(), w($, {
          key: 1,
          class: d([o(a).is("loading", e.loading)])
        }, {
          default: L(() => [
            N
          ]),
          _: 1
        }, 8, ["class"]))
      ], 64)) : B("", !0),
      t("span", null, [
        m(e.$slots, "default")
      ])
    ], 10, M));
  }
});
export {
  O as default
};
